import IconSparkles16 from '@warp-ds/icons/react/sparkles-16';
import { Button, type ButtonProps } from '@warp-ds/react';
import { useEffect, useRef } from 'react';
import { triggerSurveyEvent, useHotjar } from './useHotjar.js';

type DescriptionHelpButtonProps = {
  button?: Omit<ButtonProps, 'children'>;
};

export const DescriptionFakeDoorButton = ({ button }: DescriptionHelpButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  // const { trackEvent } = usePulse();

  useHotjar();

  useEffect(() => {
    if (typeof window !== 'undefined' && buttonRef.current) {
      /* trackEvent({
        type: 'Show',
        intent: 'Engagement',
        name: 'Description fake door button shown',
        object: {
          id: 'TAI_ev10',
        },
      }); */
    }
  }, []);

  const launchSurvey = () => {
    triggerSurveyEvent('description-fake-door');
    /* trackEvent({
      type: 'Click',
      intent: 'Engagement',
      name: 'Description fake door survey launched',
      object: {
        id: 'TAI_ev11',
      },
    }); */
  };

  return (
    <>
      <div className="mt-16 flex items-center gap-8">
        <Button {...button} ref={buttonRef} onClick={launchSurvey} className="flex items-center gap-8" small>
          <IconSparkles16 />
          Trigger Hotjar survey
        </Button>
      </div>
    </>
  );
};
